import { action, observable } from "mobx";

class PasswordResetDisambiguation {
  @observable provider;

  @observable name;

  @observable username;

  @observable userClass;

  @observable company;

  @observable checked = false;

  @observable isResetPasswordError = false;

  @observable isResetPasswordSuccess = false;

  @observable resetPasswordMessage = "";

  constructor(data) {
    this.setData(data);
  }

  @action
  setData(data) {
    const { provider, name, username, userClass, company } = data;
    this.provider = provider;
    this.name = name;
    this.username = username;
    this.userClass = userClass;
    this.company = company;
  }
}

export default PasswordResetDisambiguation;
